import ReportByAges from './ReportByAges';

const report_by_age_routes = {
  path: 'ringingreports',
  name: 'production.ringings',
  component: ReportByAges,
  meta: {
    prefix_permission: 'ringings_journals_ringingreports',
  },
};
export default report_by_age_routes;
